"use client"

import { useMemo } from "react"
import { useLocale, useTranslations } from "next-intl"
import {
  formatCredits,
  formatCreditsExpiring,
  formatCreditsShort,
  formatCreditsSigned,
} from "@/lib/billing/utils/credits"

/** UI formatting only; input parsing and stored microUSD remain unchanged. */
export function useCreditFormatters() {
  const locale = useLocale()
  const t = useTranslations("CreditFormat")
  return useMemo(() => {
    const presentation = { t, numbers: new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }) }
    return {
      formatCredits: (amount: number) => formatCredits(amount, presentation),
      formatCreditsShort: (amount: number) => formatCreditsShort(amount, presentation),
      formatCreditsSigned: (amount: number) => formatCreditsSigned(amount, presentation),
      formatCreditsExpiring: (amount: number, date: string) => formatCreditsExpiring(amount, date, presentation),
    }
  }, [locale, t])
}
